import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../assets/users.css';

const UserCalendar = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/users/${id}/calendar`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(res => res.json())
      .then(data => {
        setEvents(data.events || []);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load calendar');
        setLoading(false);
      });
  }, [id]);

  return (
    <div className="container-fluid users-page">
      <button className="btn btn-secondary" onClick={() => navigate(-1)} style={{ marginBottom: 20 }}>
        &larr; Back
      </button>
      <div className="users-table-panel" style={{ maxWidth: 600 }}>
        <div className="users-table-header-row">
          <div className="users-table-title">User Calendar</div>
        </div>
        <div className="users-table-wrapper">
          {loading ? (
            <div>Loading...</div>
          ) : error ? (
            <div>{error}</div>
          ) : (
            <div>
              <p>Calendar events for user {id}:</p>
              <pre>{JSON.stringify(events, null, 2)}</pre>
              <p style={{ color: '#888' }}>(Calendar UI coming soon)</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserCalendar; 